import { BlockView } from "common/views/block/BlockView.view";
import { DropdownSelectVariant } from "common/views/dropdownSelect/DropdownSelect.view";
import { OptionDropdownSelect } from "common/views/dropdownSelect/OptionDropdownSelect";
import TokenSession from "core/util/session/TokenSession";
import { Institution } from "core/util/session/TokenUser";
import React from "react";
import InstitutionsFilterLabels from "./InstitutionsFilter.labels";
export interface InstitutionFilterComponentProp {
    defaultInst? : string;
    setInstitution: (institituion:string,first?:boolean) => void; 
} 
const InstitutionFilterComponent = ({defaultInst,setInstitution}:InstitutionFilterComponentProp) => {
    let institutions:Institution[] = TokenSession.getUserInstitutions();							
		if(!institutions) {
			throw new Error("No Institution found for the user.");
		}
		const options = institutions.map(i=>({value:i.guid, label:i.name}));
		if(!defaultInst)
			setInstitution(options[0].value,true); //first is true to let the callback implementation know if it wants to handle differnetly 

		return (
			options?(
				<BlockView viewKey="block.institution.filter">
					<OptionDropdownSelect
						onChange={(value) => setInstitution(value)}
						options={options}
						value={defaultInst}
						variant={DropdownSelectVariant.MINIMAL}
						viewKey="refine.institution"
					>
						<InstitutionsFilterLabels.Labels.Institution />
					</OptionDropdownSelect>
				</BlockView>
			):(<React.Fragment></React.Fragment>)
		)
		
}
export default InstitutionFilterComponent;


// WEBPACK FOOTER //
// ./src/panels/institutions/InstitutionFilterComponent.tsx